import { connect } from 'react-redux';
import { openDialog } from '../../../base/dialog/actions';
import { translate } from '../../../base/i18n/functions';
import { IconTranslate } from '../../../base/icons/svg';
import AbstractButton from '../../../base/toolbox/components/AbstractButton';
import { isE2EEOnInMeeting } from '../../../e2ee/functions';
import AudioTranslationDialog from './AudioTranslationDialog';
/**
 * A toolbar button that opens the AI audio-translation language selector.
 */
class AudioTranslationButton extends AbstractButton {
    accessibilityLabel = 'toolbar.accessibilityLabel.audioTranslation';
    icon = IconTranslate;
    label = 'toolbar.audioTranslation';
    tooltip = 'toolbar.audioTranslation';
    /**
     * Handles clicking the button by opening the language selector dialog.
     *
     * @override
     * @returns {void}
     */
    _handleClick() {
        this.props.dispatch(openDialog('AudioTranslationDialog', AudioTranslationDialog));
    }
    /**
     * Indicates whether this button is in the toggled (translation-on) state.
     *
     * @override
     * @returns {boolean}
     */
    _isToggled() {
        return Boolean(this.props._language);
    }
    /**
     * Disabled while end-to-end encryption is on, unless a translation is already on and can be turned off.
     *
     * @override
     * @returns {boolean}
     */
    _isDisabled() {
        return Boolean(this.props._e2eeEnabled) && !this._isToggled();
    }
    /**
     * Why the button is disabled.
     *
     * @override
     * @returns {string}
     */
    _getDisabledReason() {
        return 'audioTranslation.unavailableWithE2EE';
    }
}
/**
 * Maps (parts of) the redux state to the button's props.
 *
 * @param {IReduxState} state - The redux state.
 * @returns {Object}
 */
function _mapStateToProps(state) {
    return {
        _e2eeEnabled: isE2EEOnInMeeting(state),
        _language: state['features/audio-translation'].language
    };
}
export default translate(connect(_mapStateToProps)(AudioTranslationButton));
